export const whenStyleChanges = (element, cb) => {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutationRecord) => {
            cb(mutationRecord)
        });
    });

    observer.observe(element, { attributes: true, attributeFilter: ['style'] });
}